import { Action, Reducer } from 'redux';
import { FileUploadState, FileUploadUnloadState } from '../states/FileUploadState';
import { FileUpload } from '../../models/Entities/Contracts/FileUpload';

// Actions
import * as Actions from '../actions/'; 

// KnownAction type union using the correct action interfaces
type KnownAction = 
    | Actions.FileUpload.FileUploadGetAllRequestAction
    | Actions.FileUpload.FileUploadGetAllSuccessAction
    | Actions.FileUpload.FileUploadGetAllFailureAction
    | Actions.FileUpload.FileUploadGetByIdRequestAction
    | Actions.FileUpload.FileUploadGetByIdSuccessAction
    | Actions.FileUpload.FileUploadGetByIdFailureAction
    | Actions.FileUpload.FileUploadCreateRequestAction
    | Actions.FileUpload.FileUploadCreateSuccessAction
    | Actions.FileUpload.FileUploadCreateFailureAction
    | Actions.FileUpload.FileUploadDeleteRequestAction
    | Actions.FileUpload.FileUploadDeleteSuccessAction
    | Actions.FileUpload.FileUploadDeleteFailureAction;

export const FileUploadReducer: Reducer<FileUploadState> = (
    state: FileUploadState | undefined, incomingAction: Action): FileUploadState => {
   
    if (state === undefined) {
        return  FileUploadUnloadState as FileUploadState;
    }

    const action = incomingAction as KnownAction;    
    
    switch (action.type) {
        case Actions.FileUpload.FILE_UPLOAD_GET_ALL_REQUEST:
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined,
                FileUploadResult: undefined
            };        
        case Actions.FileUpload.FILE_UPLOAD_GET_ALL_SUCCESS:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                FileUploads: action.Files,
                TotalCount: action.Files.length
            };

        case Actions.FileUpload.FILE_UPLOAD_GET_ALL_FAILURE:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,                
                error: action.error,
                FileUploadResult: {
                    succeeded: false,
                    message: action.error.ErrorMessage ?? 'Failed to get files',
                    statusCode: action.error.ErrorCode ?? 500,
                    errors: action.error.Errors ?? [],
                    data: null
                }
            };
        case Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_REQUEST:
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined,
                FileUploadResult: undefined
            };
        case Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_SUCCESS:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined
            };

        case Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_FAILURE:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };

        // Create File Upload
        case Actions.FileUpload.FILE_UPLOAD_CREATE_REQUEST:
            return {
                ...state,
                isUploadingFile: true,
                successUploadingFile: false,
                failOnUploadingFile: false,
                error: undefined,
                FileUploadResult: undefined
            };

        case Actions.FileUpload.FILE_UPLOAD_CREATE_SUCCESS:
            return {
                ...state,
                isUploadingFile: false,
                successUploadingFile: true,
                failOnUploadingFile: false,
                error: undefined,                
                FileUploads: [action.File, ...state.FileUploads],
                TotalCount: state.TotalCount + 1,
                FileUploadResult: {
                    succeeded: true,
                    message: 'File uploaded successfully',
                    statusCode: 200,
                    errors: [],
                    data: action.File
                }
            };

        case Actions.FileUpload.FILE_UPLOAD_CREATE_FAILURE:
            return {
                ...state,
                isUploadingFile: false,
                successUploadingFile: false,
                failOnUploadingFile: true,                error: action.error,
                FileUploadResult: {
                    succeeded: false,
                    message: action.error.ErrorMessage ?? 'Upload failed',
                    statusCode: action.error.ErrorCode ?? 500,
                    errors: action.error.Errors ?? [],
                    data: null
                }
            };

        // Delete File Upload
        case Actions.FileUpload.FILE_UPLOAD_DELETE_REQUEST:
            return {
                ...state,
                isDeletingFile: true,
                successDeletingFile: false,
                failOnDeletingFile: false,
                error: undefined,
                FileUploadResult: undefined
            };

        case Actions.FileUpload.FILE_UPLOAD_DELETE_SUCCESS:
            return {
                ...state,
                isDeletingFile: false,
                successDeletingFile: true,
                failOnDeletingFile: false,
                error: undefined,
                FileUploads: state.FileUploads.filter((file: FileUpload) => file.id !== action.FileId),
                TotalCount: state.TotalCount - 1,
                FileUploadResult: {
                    succeeded: true,
                    message: 'File deleted successfully',
                    statusCode: 200,
                    errors: [],
                    data: true
                }
            };

        case Actions.FileUpload.FILE_UPLOAD_DELETE_FAILURE:
            return {
                ...state,
                isDeletingFile: false,
                successDeletingFile: false,
                failOnDeletingFile: true,
                error: action.error,
                FileUploadResult: {
                    succeeded: false,
                    message: action.error.ErrorMessage ?? 'Delete failed',
                    statusCode: action.error.ErrorCode ?? 500,
                    errors: action.error.Errors ?? [],
                    data: null
                }
            };

        default:
            return state;
    }
};
